import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../utils/api';

const clientCache = new Map(); // url → data | null(실패)

const httpUrl = (value) => {
    try {
        const u = new URL(value);
        return u.protocol === 'http:' || u.protocol === 'https:' ? u.href : null;
    } catch { return null; }
};

export function LinkPreview({ url, onLoad }) {
    const [data, setData] = useState(() => clientCache.get(url) || null);

    useEffect(() => {
        if (clientCache.has(url)) { setData(clientCache.get(url)); return; }
        let alive = true;
        apiFetch(`/api/link-preview?url=${encodeURIComponent(url)}`)
            .then(r => (r.ok ? r.json() : null))
            .catch(() => null)
            .then(d => {
                clientCache.set(url, d);
                if (alive) setData(d);
            });
        return () => { alive = false; };
    }, [url]);

    if (!data) return null;

    const parsed = (() => { try { return new URL(url); } catch { return null; } })();
    const domain = parsed ? parsed.hostname.replace(/^www\./, '') : '';
    const favicon = httpUrl(data.favicon);
    const image = httpUrl(data.image);

    return (
        <a className="link-preview-card" href={url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
            <div className="link-preview-body">
                <div className="link-preview-site">
                    {favicon && <img className="link-preview-favicon" src={favicon} alt="" loading="lazy" referrerPolicy="no-referrer" onError={e => { e.target.style.display = 'none'; }} />}
                    <span>{data.siteName || domain}</span>
                </div>
                {data.title && <div className="link-preview-title">{data.title}</div>}
                {data.description && <div className="link-preview-desc">{data.description}</div>}
                {image && (
                    <div className="link-preview-image-wrapper">
                        <img className="link-preview-image" src={image} alt={data.title || ''} loading="lazy" decoding="async" referrerPolicy="no-referrer" onLoad={onLoad} onError={e => { e.target.parentElement.style.display = 'none'; }} />
                    </div>
                )}
            </div>
        </a>
    );
}
